module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACsSURBVEhL3ZVBDsJADAP3d5Xg/x8o/KNkD5Eaa2IoqIcykg+xZ+HY8XfcI8/I9mXm21uk5RGhh0eyRlpSInQjl7qCE3Qjl7qCE3TLm9LiBN3yprQ4QTdyqSs4QTdyqSuosL+7jdKiwv7uNkqLE3Qjl7qCE3Qjl7qCE3TLm9LiBN3yprQ4QTdyqSs4QTdyqSs4QTdyqSuc/j2YX6Nf/mT++BJ5Sz74lKP+ZRjjBdSL1XAc/La5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-sliding-door-closet/dark/24.png
// module id = 2420
// module chunks = 2